export default __webpack_public_path__ + "static/media/TV.1a89b43f.svg";